import React from 'react';
import type { PreferenceService } from './types';

const defaultImpl: PreferenceService = {};
const PreferenceContext = React.createContext<unknown>(defaultImpl);

PreferenceContext.displayName = 'PreferenceContext';

export {
  PreferenceContext,
};
